import { createSlice } from "@reduxjs/toolkit";

const validatorSlice = createSlice({
  name: "validator",
  initialState: {
    validatorDetails: [],
    assignedFolders: [],
    assignedFiles: [],
    selectedAssignedProjectId: null,
    selectedAssignedFolderId: null,
    selectedAssignedFileId: null,
    selectedFile: {},
    isFileValidated: false,
    targetLanguageId: null,
    fileStatus: null
  },
  reducers: {
    addValidatorDetails: (state, action) => {
      state.validatorDetails = action.payload;
    },
    addAssignedFolders: (state, action) => {
      state.assignedFolders = {
        ...state.assignedFolders,
        [state.selectedAssignedProjectId]: action.payload,
      };
    },
    addAssignedFiles: (state, action) => {
      state.assignedFiles = {
        ...state.assignedFiles,
        [state.selectedAssignedFolderId]: action.payload,
      };
    },
    setSelectedAssignedProjectId: (state, action) => {
      state.selectedAssignedProjectId = action.payload;
    },
    setSelectedAssignedFolderId: (state, action) => {
      state.selectedAssignedFolderId = action.payload;
    },
    setSelectedAssignedFileId: (state, action) => {
      state.selectedAssignedFileId = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setTargetLanguageId: (state, action) => {
      state.targetLanguageId = action.payload;
    },
    setIsFileValidated: (state,action)=>{
      state.isFileValidated=action.payload;
    },
    setFileStatus: (state,action)=>{
      state.fileStatus=action.payload;
    }
  },
});

export const {
  addValidatorDetails,
  addAssignedFolders,
  addAssignedFiles,
  setSelectedAssignedProjectId,
  setSelectedAssignedFolderId,
  setSelectedAssignedFileId,
  setSelectedFile,
  setTargetLanguageId,
  setIsFileValidated,
  setFileStatus
} = validatorSlice.actions;

export default validatorSlice.reducer;